import { AlertIcon } from '@approvalmax/ui';
import { Alert, Button, Flex, Link, List, Popup, Text } from '@approvalmax/ui/src/components';
import { useSelector } from 'modules/react-redux';
import { getRequest } from 'pages/requestForm/selectors/pageSelectors';
import { memo } from 'react';
import { getPath, Path } from 'urlBuilder';

import { messages } from './PopupContent.messages';
import { PopupContentProps } from './PopupContent.types';

export const PopupContent = memo<PopupContentProps>((props) => {
    const { duplicates, onCancel, onSubmit } = props;

    const request = useSelector(getRequest);

    return (
        <>
            <Popup.Header title={messages.title} />

            <Popup.Body spacing='20 32 48'>
                <Flex direction='column'>
                    <Alert size='large' startIcon={<AlertIcon />} alignItems='center'>
                        <Text font='body' fontSize='large'>
                            {messages.description}
                        </Text>
                    </Alert>

                    <List spacing='16 0' removeLastSpacing>
                        {duplicates.map((item) => (
                            <List.Item key={item.requestId}>
                                <Link
                                    font='label'
                                    fontSize='large'
                                    href={getPath(Path.request, item.requestId, request.companyId)}
                                    external
                                >
                                    {item.friendlyName}
                                </Link>
                            </List.Item>
                        ))}
                    </List>

                    <Flex justifyContent='end'>
                        <Button onClick={onCancel} color='red40'>
                            {messages.cancel}
                        </Button>

                        <Button onClick={onSubmit} color='blue80'>
                            {messages.submit}
                        </Button>
                    </Flex>
                </Flex>
            </Popup.Body>
        </>
    );
});

PopupContent.displayName = 'PopupContent';
